<template>
    <header
        class="white sh3"
        v-bind:class="{ 'transparent--bg': !darken, 'header-alt': darken }"
    >
        <w-flex class="wrapper mt-0 justify-space-between">
            <div class="" @click="showmenu">
                <w-button
                    class="ma1"
                    icon="fal fa-bars"
                    bg-color="transparent"
                />

                {{ $page.props.app_name }}
            </div>

            <div v-if="0">
                <w-icon class="ml2" md color="grey-light5">
                    fal fa-signal
                </w-icon>
                <w-icon class="ml2" md color="grey-light5">
                    fal fa-wifi
                </w-icon>
                <w-icon class="ml2" md color="grey-light5">
                    fal fa-battery-bolt
                </w-icon>
            </div>

            <div class="justify end no-shrink row leftbox">
                <w-menu
                    min-width="200"
                    shadow
                    align-right
                    color="white"
                    bg-color="indigo-dark4"
                    content-class="ma0 pa0"
                >
                    <template #activator="{ on }">
                        <template
                            v-on="on"
                            class="mr5"
                            bg-color="light-blue-light5"
                            color="primary-dark1"
                            overlap
                            xs

                        >
                            <!-- <template #badge>{{
                                notifications.length
                            }}</template>
                            <w-icon class="fail" lg>fal fa-bell</w-icon> 
                            </w-badge> -->
                        </template>
                    </template>
                    <w-list :items="notifications" checklist> </w-list>
                </w-menu>
                <span style="color: black;">

                {{ $page.props.auth.user.name }}
                ({{ $page.props.auth.user.jabatan_keterangan }})
                </span>
                <w-image
                    class="mr1 ml1 bd1 sh1 bdrs1 d-block white--bg"
                    src="/images/avatar.svg"
                    :width="30"
                    :height="30"
                >
                </w-image>

                <w-menu
                    min-width="200"
                    shadow
                    align-right
                    color="white"
                    bg-color="indigo-dark4"
                    content-class="ma0 pa0"
                >
                    <template #activator="{ on }">
                        <w-icon v-on="on" class="mr-2" md color="grey-light5">
                            fal fa-bars
                        </w-icon>
                    </template>
                    <z-menu :menu="menus" icon-expand="fal fa-chevron-up" />
                </w-menu>
            </div>
        </w-flex>
    </header>
</template>

<script>
import ZMenu from "./Menu";

export default {
    components: {
        ZMenu,
    },
    data() {
        return {
            hover: false,
            menu: true,
            autohidemenu: false,
            darken: false,
            menus: [
                {
                    label: "Utama",
                    icon: "fal fa-home",
                    route: this.$route('home'),
                    remove: "no",
                    child: [],
                },
                {
                    label: "Tukar Kata Laluan",
                    icon: "fal fa-lock",
                    route: this.$route('changePassword'),
                    remove: "no",
                    child: [],
                },
                {
                    label: "Log Keluar",
                    icon: "fal fa-sign-out",
                    route: this.$route('logout'),
                    remove: "no",
                    child: [],
                },
                
            ],
            notifications: [
                // this is sample
                {
                    label: "Prince Nigeria Contacting You",
                    preview: "",
                    color: "success",
                    icon: "fal fa-home",
                    route: "/home",
                },
                {
                    label: "Powder Becoming Jinx!",
                    preview: "",
                    color: "warning",
                    icon: "fal fa-sign-out",
                    route: "logout",
                },
                {
                    label: "Progress Day Preparation Meeting",
                    preview: "",
                    color: "info",
                    icon: "fal fa-sign-out",
                    route: "/logout",
                },
            ],
        };
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
        window.addEventListener("mousemove", this.onMouseMove);
        console.log(this.$waveui.breakpoint.name);
        // if(!this.$waveui.breakpoint.lg) {
        //   this.menu = (localStorage.getItem('showmenu') === 'true' || localStorage.getItem('showmenu') === null)
        //   this.autohidemenu = !this.menu
        // }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("mousemove", this.onMouseMove);
    },
    methods: {
        showmenu() {
            this.menu = !this.menu;
            this.autohidemenu = !this.menu;
            localStorage.setItem("showmenu", this.menu);
        },
        onScroll(e) {
            let y =
                window.top.scrollY; /* or: e.target.documentElement.scrollTop */

            if (y > 70) {
                this.darken = true;
            } else {
                this.darken = false;
            }
        },
        onMouseMove(e) {
            let x = e.clientX;
            // console.log(x)
            if (x <= 0 && !this.menu) {
                this.menu = true;
            }

            if (x >= 250 && this.autohidemenu) {
                this.menu = false;
            }
        },
    },
    watch: {
        menu: function (val) {
            if (val) {
                document
                    .getElementsByClassName("zsidebar")[0]
                    .classList.remove("zhidemenu");
            } else {
                document
                    .getElementsByClassName("zsidebar")[0]
                    .classList.add("zhidemenu");
            }
        },
    },
};
</script>

<style>
header {
    /* text-transform: uppercase; */
    margin: 0px;
    padding: 12px;
    min-height: 20px;
    position: fixed;
    width: 100%;
    z-index: 399;
}

.header-alt {
    background-color: rgba(24, 26, 60, 0.9);
    position: fixed;
    transition: all 0.5s;
}

.leftbox {
    display: flex;
    align-items: center;
}


</style>
